import styles from '../styles/font/index.module.scss'
import { List, Card, Tag } from 'antd'
import Layout from '../../components/MyLayout'
import React from 'react'
import { NextPage, NextPageContext } from 'next';
import { curriculumClass, getCourseList } from '../../constants/api'
import {http} from '../../utils/api'
import { useSelector } from 'react-redux'
import { State } from '../../@types/reducer'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Meta from 'antd/lib/card/Meta';
import Paragraph from 'antd/lib/typography/Paragraph';
import { Class, Item } from '../../@types/curriculum';
import { colorPrimary, title } from '../../constants/heads';
type CurriculumProps = {
  page: number
  level: number
  charge: number
  category: string | string[]
  style: number
  by: string | string[]
  list: {
    list: Item[]
    total: number
  }
  classList: Class[]
}

const typeList = [
  {
    name: '图文',
    type: 1
  },
  {
    name: '视频',
    type: 2
  }
],
  levelList = [
    {
      name: '入门',
      type: 1
    },
    {
      name: '初级',
      type: 2
    },
    {
      name: '中级',
      type: 3
    },
    {
      name: '高级',
      type: 4
    }
  ],
  costList = [
    {
      name: '免费',
      type: 1
    },
    {
      name: '收费',
      type: 2
    }
  ]

const Curriculum: NextPage<CurriculumProps> = (props) => {
  const router = useRouter()
  const { query } = useRouter()
  const {
    page,
    style,
    level,
    charge,
    category,
    by,
  } = props

  const { total, list } = props.list
  const classList = props.classList

  const head = {
    title: `搜图教程-提供免费优质设计教程文章、视频`,
    keywords: `设计教程`,
    description: `只精选最优质的C4D教程、UI教程、PS教程、AI教程、视觉教程、设计教程等等。看设计教程就上${title}`
  }
  const { userInfo, baseUrl, cdnUrl, responsive } = useSelector((state: State) => state)
  const { isXs, isSm, isMd, isXxl } = responsive

  const onSearch = (value: any) => {
    const text = value.constructor === String ? String(value) : value.target.defaultValue
    router.push(`/curriculum?key=${text}`)
  }

  const levelFil = (val: number) => {
    let name = "";
    levelList.map((v, k) => {
      if (val == v.type) name = v.name;
    });
    return name;
  }

 

  return (
    <Layout className={styles.font} head={head}>
      <div className={styles.content} style={{ marginTop: "20px" }}>
        {/* <Search
          placeholder="请输入关键词进行搜索"
          enterButton={<SearchIcon style={{ padding: '0 15px' }} strokeWidth={3} theme="outline" size="22" fill="#fff" strokeLinecap="butt" />}
          size="large"
          onPressEnter={onSearch}
          onSearch={onSearch}
        /> */}
        <Card>
          <div>
            <span>分类：</span>
            <Link key="k" href={
              {
                pathname: '/curriculum',
                query: { ...query, category: '', p: 1 },
              }
            } >
              <a>
                <Tag style={category == '' ? { color: '#fff' } : {}} color={category == '' ? colorPrimary : '#fff'}>全部</Tag>
              </a>
            </Link>
            {classList.map((v, k: number) => (
              <Link key={k} href={{
                pathname: '/curriculum',
                query: { ...query, category: v._id, p: 1 },
              }} >
                <a>
                  <Tag style={category == v._id ? { color: '#fff' } : {}} color={category == v._id ? colorPrimary : '#fff'}>{v.name}</Tag>
                </a>
              </Link>
            ))}
          </div>

          <div>
            <span>类型：</span>
            <Link key="k" href={
              {
                pathname: '/curriculum',
                query: { ...query, style: '', p: 1 },
              }
            } >
              <a>
                <Tag style={!style ? { color: '#fff' } : {}} color={!style ? colorPrimary : '#fff'}>全部</Tag>
              </a>
            </Link>
            {typeList.map((v, k: number) => (
              <Link key={k} href={{
                pathname: '/curriculum',
                query: { ...query, style: v.type, p: 1 },
              }} >
                <a>
                  <Tag style={style == v.type ? { color: '#fff' } : {}} color={style == v.type ? colorPrimary : '#fff'}>{v.name}</Tag>
                </a>
              </Link>
            ))}
          </div>

          <div>
            <span>级别：</span>
            <Link key="k" href={
              {
                pathname: '/curriculum',
                query: { ...query, level: '', p: 1 },
              }
            } >
              <a>
                <Tag style={!level ? { color: '#fff' } : {}} color={!level ? colorPrimary : '#fff'}>全部</Tag>
              </a>
            </Link>
            {levelList.map((v, k: number) => (
              <Link key={k} href={{
                pathname: '/curriculum',
                query: { ...query, level: v.type, p: 1 },
              }} >
                <a>
                  <Tag style={level == v.type ? { color: '#fff' } : {}} color={level == v.type ? colorPrimary : '#fff'}>{v.name}</Tag>
                </a>
              </Link>
            ))}
          </div>

          <div>
            <span>费用：</span>
            <Link key="k" href={
              {
                pathname: '/curriculum',
                query: { ...query, charge: '', p: 1 },
              }
            } >
              <a>
                <Tag style={!charge ? { color: '#fff' } : {}} color={!charge ? colorPrimary : '#fff'}>全部</Tag>
              </a>
            </Link>
            {costList.map((v, k: number) => (
              <Link key={k} href={{
                pathname: '/curriculum',
                query: { ...query, charge: v.type, p: 1 },
              }} >
                <a>
                  <Tag style={charge == v.type ? { color: '#fff' } : {}} color={charge == v.type ? colorPrimary : '#fff'}>{v.name}</Tag>
                </a>
              </Link>
            ))}
          </div>

          <div>
            <span> 排序：</span>
            <Link key="timestamp" href={{
              pathname: '/curriculum',
              query: { ...query, by: "", p: 1 },
            }} >
              <a><Tag style={by == '' ? { color: '#fff' } : {}} color={by == '' ? colorPrimary : '#fff'}>默认</Tag></a>
            </Link>
            <Link key="creat_date" href={{
              pathname: '/curriculum',
              query: { ...query, by: "creat_date", p: 1 },
            }} >
              <a>
                <Tag style={by == 'creat_date' ? { color: '#fff' } : {}} color={by == 'creat_date' ? colorPrimary : '#fff'}>最新</Tag>
              </a>
            </Link>
            <Link key="visit" href={{
              pathname: '/curriculum',
              query: { ...query, by: "visit", p: 1 },
            }} >
              <a>
                <Tag style={by == 'visit' ? { color: '#fff' } : {}} color={by == 'visit' ? colorPrimary : '#fff'}>热门</Tag>
              </a>
            </Link>
          </div>
        </Card>
        <List
          itemLayout="vertical"
          size="large"
          pagination={{
            itemRender: (current, type, originalElement) => {
              if (type === 'page') {
                return <Link href={{
                  pathname: '/curriculum',
                  query: { ...query, p: current },
                }} ><a>{current}</a></Link>
              }
              return originalElement;
            },
            current: page,
            total,
            pageSize: 16,
            hideOnSinglePage: true
          }}
          dataSource={list}
          footer={null}
          grid={{
            gutter: 0, xs: 1, sm: 3, md: 3, lg: 3, xl: 4, xxl: 4,
          }}
          renderItem={item => (
            <List.Item style={{ marginBottom: 0 }}>
              <Link href={
                {
                  pathname: '/curriculum/[id]',
                  query: { id: item._id },
                }
              } >
                <a target="_blank" title={item.title}>
                  <Card
                    style={{ width: '100%', marginBottom: 0 }}
                    actions={[item.category_name,levelFil(item.level),item.style ==1?'图文':'视频']}
                    cover={
                      <img
                        alt={item.title}
                        style={{ height: '176px', objectFit: 'cover' }}
                        src={item.cover.indexOf('http') != -1 ? item.cover : cdnUrl + '/' + item.cover}
                      />
                    }
                  >
                    <Meta
                      title={item.title}
                      description={<Paragraph style={{ width: '100%', marginBottom: 0 }} ellipsis={true}>
                        {item.vice}
                      </Paragraph>}
                    />
                  </Card>
                </a>
              </Link>
            </List.Item>
          )}
        />
      </div>
    </Layout>
  )
}

Curriculum.getInitialProps = async ({ req, res, err, query }: NextPageContext) => {
  const page = query.p || 1;
  const category = query.category || "";
  const style = query.style || 0;
  const level = query.level || 0;
  const charge = query.charge || 0;
  const by = query.by || ""
  const key = query.key || ""
  const limit = 16

  const data: any = await Promise.all([http(curriculumClass), http(getCourseList, {
    style,
    level,
    charge,
    page,
    category,
    limit,
    by,
    key
  }, req)])
  const classList: any = data[0].data
  const list: any = data[1].data
  return {
    list: list,
    classList: classList.list,
    page: Number(page),
    style: Number(style),
    level: Number(level),
    charge: Number(charge),
    category,
    limit,
    by,
  }
}

export default Curriculum

